import React from 'react';

export default function DeclutterIcon() {
  return (
    <img
      src="/Favicon.png"
      alt=""
      className="sky-fan-icon"
    />
  );
}
